import { FC } from "react";

interface IpoListNotFoundProps {
  errorMessage: string;
  fetchError: boolean;
}

const IpoListNotFound: FC<IpoListNotFoundProps> = ({ errorMessage, fetchError }) => {
    const imageSrc = fetchError
        ? "https://cms-assets.bajajfinserv.in/is/image/bajajfinance/error_scenario"
        : "https://cms-assets.bajajfinserv.in/is/image/bajajfinance/no-stocks";
  return (
    <section
      className="
        flex flex-col items-center justify-center text-center max-w-[892px]
        border border-[#e5e5e5] rounded
        py-[28px] mb-[12px]
      "
    >
      <img
        src={imageSrc}
        alt="ipo list not found"
        loading="lazy"
        className="
          w-[140px] h-[160px] box-border
          p-[7px_9px_7px_19px]
          sm:w-[94.67px] sm:h-[110.9px] sm:p-[5px_13px]
        "
      />
      <p
        className="
          text-[#1a1a1a] leading-6 mt-3
          min-w-[426px] text-sm
          sm:min-w-[236px] sm:text-[12px]
        "
      >
        {errorMessage}
      </p>
    </section>
  );
};

export default IpoListNotFound;
